import qs from 'qs';
import { runtimeConfig } from '../../config/runtimeConfig';

import client from '../client';
import type {
  ICompanyListParams,
  ICompanyRegData,
  ICreateCompanyUserParams,
  IGetAdminModlinkListParams,
  IGetCompanyParams,
  IPostCompleteUploadParams,
  IPostOpenApiKeyParams,
  IPutCompanyDetailParams,
  IUpdateCompanyParams,
} from './types';

const API_SERVICE_CHANNEL_PLAN_STAGE = runtimeConfig.apiServiceChannelPlanStage;

export const companyApis = {
  // 거래처 관리
  companyList: (data: ICompanyListParams) =>
    client.get('/company', {
      params: { ...data },
      paramsSerializer: {
        serialize: function (params) {
          return qs.stringify(params, { arrayFormat: 'brackets' });
        },
      },
    }),
  getCompany: (data: IGetCompanyParams) => client.get(`/companies/details/${data.id}`),
  assignMaster: (data: ICreateCompanyUserParams) => client.post(`/company/${data.companyId}/user`, { ...data }),
  updateCompany: (data: IUpdateCompanyParams) => client.put(`/company/${data.id}`, data.data),
  registerCompany: (data: ICompanyRegData) => client.post('/company', data),

  // 회사 디바이스 목록 조회
  getAdminModlinkList: (params: IGetAdminModlinkListParams) =>
    client.get(`/company/${params.companyId}/device`, {
      params: { ...params.data },
      paramsSerializer: {
        serialize: function (params) {
          return qs.stringify(params, { arrayFormat: 'brackets' });
        },
      },
    }),

  putCompanyDetail: (data: IPutCompanyDetailParams) => client.put(`/companies/extension/${data.companyId}`, data.data),
  postCompleteUpload: (data: IPostCompleteUploadParams) =>
    client.post(`/extension/model-upload/complete/${data.fileUploadId}`, {
      fileSize: data.fileSize,
    }),
  getApiServiceChannelPlan: () =>
    client.get(`/usage-plan`, {
      params: { provider: 'AWS', stage: API_SERVICE_CHANNEL_PLAN_STAGE },
    }),
  getCompanyUsagePlan: (companyId: number) => client.get(`/usage-plan/${companyId}`),
  postOpenApiKey: (data: IPostOpenApiKeyParams) => client.post(`/usage-plan/${data.usagePlanId}/api-keys`, data),
};
